document.addEventListener('DOMContentLoaded', () => {
  initTinaReveal();
  initTinaFaq();
});

document.addEventListener('shopify:section:load', () => {
  initTinaReveal();
  initTinaFaq();
});

function initTinaReveal() {
  const elements = document.querySelectorAll(
    '[data-tina-reveal]:not([data-tina-ready])'
  );

  if (!elements.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px',
    }
  );

  elements.forEach((element) => {
    element.dataset.tinaReady = 'true';
    observer.observe(element);
  });
}

function initTinaFaq() {
  document
    .querySelectorAll('[data-tina-faq-button]:not([data-tina-ready])')
    .forEach((button) => {
      button.dataset.tinaReady = 'true';

      button.addEventListener('click', () => {
        const item = button.closest('.tina-faq__item');

        if (!item) return;

        const isOpen = item.classList.toggle('is-open');

        button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
}